/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { createTheme } from "@mui/material/styles";
// Constants
import { Color } from "../../constants";

const theme = createTheme();

export const useStyles = () => ({
    navbarContainer: css({
        position: "fixed",
        width: "100%",
        top: 0,
        zIndex: 1000,
    }),
    navbar: css({
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.up('md')]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: "10%",
            paddingRight: "10%",
        },
        height: "64px",
        background: Color.gradient[100],
    }),
    navbarLogoContainer: css({
        marginRight: 100,
    }),
    navbarLogo: css({
        width: `88px !important`,
        height: `44px !important`,
        cursor: "pointer",
    }),
    navbarAccountIconContainer: css({
        "& svg": {
            width: 30,
            height: 30,
            marginRight: 24,
            color: Color.primary[100],
            cursor: "pointer",
        },
    }),
    navbarShoppingCartIconContainer: css({
        position: 'relative',
        marginTop: 10,
        "& svg": {
            width: 36,
            height: 36,
            marginRight: 24,
            color: Color.primary[100],
            cursor: "pointer",
        },
    }),
    navbarCollectionSizeIndicator: css({
        position: 'absolute',
        top: -10,
        right: 20,
        width: 23,
        height: 23,
        background: Color.alert[700],
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }),
    navbarChildContainer: css({
        height: "100%",
        display: "inline-flex",
        alignItems: "center",
        flexGrow: 1,
        justifyContent: "flex-end",
    }),
    navbarAccountImage: css({
        width: 32,
        height: 32,
        borderRadius: "50%",
        backgroundColor: Color.primary[100],
        marginRight: 24,
        cursor: "pointer",
    }),
});
